import React from 'react';
import { Link } from 'gatsby';
import {
  faArrowLeftLong,
  faArrowRightLong,
} from '@fortawesome/pro-light-svg-icons';
import styled from 'styled-components';
import { rem } from 'polished';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ArticleThumb } from '@/components/ArticleThumb';
import { RelatedArticles } from '@/components/RelatedArticles';
import { Newsletter } from '../../../components/Newsletter';
import { Disqus } from '../../../components/Disqus';
import { Share } from '../../../components/Share';
import { SiblingArticle } from '../index';

interface BottomContentProps {
  isPreview?: string;
  title: string;
  slug: string;
  nextArticle?: SiblingArticle;
  prevArticle?: SiblingArticle;
  metaDescription: string;
  relatedArticlesToDisplay: any;
  classPrefix?: string;
  nextPrevNoImage?: boolean;
}

const StyledBottomContent = styled.div`
  .article-content__next-prev {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: ${rem(`24px`)};
    margin-top: ${rem(`48px`)};
    margin-bottom: ${rem(`48px`)};
    ${({ theme }) => theme.breakpoints.desktop`
      column-gap: ${rem(`48px`)};
    `}
  }
  .article-content-container {
    width: 100%;
    text-align: left;
    margin-bottom: ${rem(`48px`)};
    padding: ${rem(`24px`)};
    border-radius: ${rem(`12px`)};
    background-color: ${({ theme }) => theme.colors.blue_1_65};
    color: ${({ theme }) => theme.colors.gray_3};
    &:last-child {
      margin-bottom: 0;
    }
    > div {
      margin-bottom: 0;
    }
  }
`;

export const BottomContent = ({
  isPreview,
  title,
  slug,
  nextArticle,
  prevArticle,
  metaDescription,
  relatedArticlesToDisplay,
  classPrefix,
  nextPrevNoImage = false,
}: BottomContentProps) => {
  return (
    <StyledBottomContent>
      {(prevArticle?.slug || nextArticle?.slug) && (
        <div className="article-content__next-prev">
          <div className="prev-article">
            {prevArticle?.slug && (
              <Link to={prevArticle.slug} className="prev-article__link">
                <ArticleThumb
                  thumbnail={prevArticle.image}
                  excerpt={prevArticle.excerpt}
                  navPosition="left"
                  noImage={nextPrevNoImage}
                >
                  <FontAwesomeIcon icon={faArrowLeftLong} />
                  <span>Prev</span>
                </ArticleThumb>
              </Link>
            )}
          </div>
          {nextArticle?.slug && (
            <div className="next-article">
              <Link to={nextArticle.slug} className="next-article__link">
                <ArticleThumb
                  thumbnail={nextArticle.image}
                  excerpt={nextArticle.excerpt}
                  navPosition="right"
                  noImage={nextPrevNoImage}
                >
                  <span>Next</span>
                  <FontAwesomeIcon icon={faArrowRightLong} />
                </ArticleThumb>
              </Link>
            </div>
          )}
        </div>
      )}

      {isPreview === `false` ? (
        <div className="article-content-container">
          <Share
            heading="Share"
            title={title}
            slug={`/blog/${slug}`}
            excerpt={metaDescription}
          />
        </div>
      ) : null}

      {isPreview === `false` ? (
        <div className="article-content-container">
          <Disqus heading="Feedback" title={title} slug={slug} />
        </div>
      ) : null}

      <RelatedArticles
        className={
          classPrefix ? `${classPrefix}-releated-articels` : `releated-articels`
        }
        articles={relatedArticlesToDisplay}
      />

      <Newsletter
        className={classPrefix ? `${classPrefix}-newsletter` : `newsletter`}
        id="newsletter_article"
      />
    </StyledBottomContent>
  );
};
